import $ from "jquery"

$(function() {
    const $overlaymenu = $("#overlaymenu");
    const $menubutton = $("#menubutton");
    const $body = $("body");

    $menubutton.on("click", function() {
        toggleOverlayMenu();
    });

    function toggleOverlayMenu() {
        const overlaymenuVisible = $overlaymenu.hasClass("visible");
        if(overlaymenuVisible) {
            hideOverlayMenu();
        } else {
            showOverlayMenu();
        }
    }

    function showOverlayMenu() {
        $overlaymenu.addClass("visible");
        $menubutton.addClass("is-active");
        $body.addClass("overlaymenuvisible");
    }

    function hideOverlayMenu() {
        $overlaymenu.removeClass("visible");
        $menubutton.removeClass("is-active");
        $body.removeClass("overlaymenuvisible");
    }

    function enhanceHtml() {
        $overlaymenu.find("li.hassubmenu > a").append('<svg class="icon icon-arrowdown"><use xlink:href="#icon-arrowdown"></use></svg>');
    }
    enhanceHtml();
});
